import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PRODUCTION_DOMAIN } from '@/lib/constants';

const META_KEYS = [
  { selector: 'link[rel="canonical"]', attr: 'href' as const },
  { selector: 'meta[property="og:url"]', attr: 'content' as const },
  { selector: 'meta[name="twitter:url"]', attr: 'content' as const },
];

/**
 * Keeps canonical / OG URLs aligned with VITE_SITE_URL (production: https://vestacfo.app).
 */
export default function SiteMeta() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const base = import.meta.env.DEV ? window.location.origin : PRODUCTION_DOMAIN;
    const pageUrl = `${base}${pathname}${search}`;

    for (const { selector, attr } of META_KEYS) {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, pageUrl);
    }
  }, [pathname, search]);

  return null;
}
